export default __webpack_public_path__ + "static/media/leads-green-icons.987a88e1.svg";